/* #region header */
/**************************************************************************************************
//
//  Description: Street Status DropDown, refactored from asd forms
//
//  Copyright:    © 2020 - 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   27.01.21 Peter Bryden               Initial Revision.
//    002   08.02.21 Sean Flook         WI38232 Set requiredField.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion header */

/* #region imports */
import React, { useState } from "react";
import AAAvatarSelect from "../AAAvatarSelect";

/* #endregion imports */

const ASDStreetStatusDropDown = ({ streetStatus_data, selectedValue, changeHandler, dataRequired }) => {

  const dataKey = "roadStatusCode";
  const dataText = "roadStatusText";

  const [data, setData] = useState(streetStatus_data);
  const [selectedKey, setSelectedKey] = useState(selectedValue);

  const handleChange = (event) => { if (changeHandler != null) changeHandler(event.value[dataKey]); }

  return (
    <AAAvatarSelect
      data={data}
      avatarField={dataKey}
      textField={dataText}
      keyField={dataKey}
      placeholder="choose street status"
      selectedKey={selectedKey}
      colour="brown"
      requiredField={dataRequired}
      onChange={handleChange}
    />
  );
}

export default ASDStreetStatusDropDown;